import { path } from 'ramda';

export const CONTAINER_APP = 'containerApp';

export const isActive = (history) => {
  const containerApp = path(
    ['query', CONTAINER_APP],
    history.getCurrentLocation(),
  );


  return Boolean(containerApp);
};

export const persistQuery = (prevState, nextState, replace, callback) => {
  const getContainerApp = path(['location', 'query', CONTAINER_APP]);
  if (getContainerApp(prevState) && !getContainerApp(nextState)) {
    replace({
      pathname: nextState.location.pathname,
      query: {
        ...nextState.location.query,
        [CONTAINER_APP]: true,
      },
    });
  }
  callback();
};

export const isEngageRoute = (history) => {
  const { pathname } = history.getCurrentLocation();
  return pathname.includes('/engagement') || pathname.includes('/engagement-v2');
};
